const AccordianClose = ({clr}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 6" width={8} height={6} fill="none">
    <path
      fill={clr || "#80A6AF"}
      d="M4.017 3.954 7.309.662 8 1.353 4.016 5.337 0 1.353l.691-.69"
    />
  </svg>
)

export default AccordianClose